import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { createShare, deactivateShare, getShareStatus } from '@/lib/api/amazon-listing'
import type { AuditShareStatus } from '@/lib/api/amazon-listing.types'

export function useAuditShareStatus(jobId: string | null) {
  return useQuery({
    queryKey: ['amazon-audit', 'share', jobId],
    queryFn: () => getShareStatus(jobId!),
    enabled: !!jobId,
    staleTime: 30_000,
  })
}

export function useAuditShareActions(jobId: string | null) {
  const qc = useQueryClient()
  const queryKey = ['amazon-audit', 'share', jobId]

  const create = useMutation({
    mutationFn: (options?: { password?: string; include_remake?: boolean }) =>
      createShare(jobId!, options),
    onSuccess: (data) => {
      qc.setQueryData<AuditShareStatus>(queryKey, {
        exists: true,
        is_active: data.is_active,
        share_token: data.share_token,
        share_url: data.share_url,
        expires_at: data.expires_at,
        has_password: data.has_password,
        include_remake: data.include_remake,
      })
    },
  })

  const deactivate = useMutation({
    mutationFn: () => deactivateShare(jobId!),
    onSuccess: () => qc.invalidateQueries({ queryKey }),
  })

  return { create, deactivate }
}
